import { render, staticRenderFns } from "./PolicyOtherDetails.vue?vue&type=template&id=405b167c&"
import script from "./PolicyOtherDetails.vue?vue&type=script&lang=js&"
export * from "./PolicyOtherDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports